import { useCallback } from 'react';

import { useAtom } from '@xstate/store/react';

import type { AudioPlayerStreamingAction } from '../effects/AudioPlayerStreamingManager';
import {
	audioPlayerStreamingStore,
	setAudioPlayerStreamingStore,
} from '../state/AudioPlayerStreamingStore';

export const useAudioPlayerStreamingStore = <TResponse extends ReadableStream>() => {
	const state = useAtom(audioPlayerStreamingStore);

	const setAudioPlayerStreamingState = useCallback(
		(action: AudioPlayerStreamingAction<TResponse>) => {
			setAudioPlayerStreamingStore(action);
		},
		[],
	);

	return { state, setAudioPlayerStreamingState };
};
